module.exports = __webpack_public_path__ + "img/search.d1644528.svg";